import SituacaoJulgamento, { RESULTADO_JULGAMENTO } from '@/dominio/ResultadoJulgamento';
import Gavel from '@mui/icons-material/Gavel';
import {
    Box,
    Button,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    List,
    ListItem,
    Tooltip,
    Typography
} from '@mui/material';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import moment from 'moment';
import ReactComponent from '../ReactComponent';
import AlterarSituacaoJulgamento from './AlterarSituacaoJulgamento';

class ResultadoJulgamento extends ReactComponent {
    abrirDialog = false;
    detalhesProcessoSessao;

    constructor(props) {
        super(props);

        makeObservable(this, {
            registro: computed,
            resultadoJulgamento: computed,
            corIcone: computed,
            textoSituacaoJulgamento: computed,
            abrirDialog: observable,
            detalhesProcessoSessao: observable,
            mostrarDetalhes: action,
            handleCloseDialog: action
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    get resultadoJulgamento() {
        return this.registro.resultadoJulgamento;
    }

    get corIcone() {
        return SituacaoJulgamento.getCorByCodigo(this.registro.resultadoJulgamento.codigo);
    }

    get textoSituacaoJulgamento() {
        let title = this.resultadoJulgamento.descricao;

        if (
            this.resultadoJulgamento.codigo === RESULTADO_JULGAMENTO.VISTA_REGIMENTAL.codigo &&
            this.registro?.informacoesAdicionais?.VistaRegimental
        ) {
            const vistas = this.registro.informacoesAdicionais.VistaRegimental;
            title +=
                ' (' +
                vistas.map((vista, index) => {
                    const sigla = vista.sigla;
                    return index < vistas.length ? sigla : sigla + ', ';
                }) +
                ')';
        }

        if (!this.registro.acordaoObrigatorio && this.registro?.informacoesAdicionais?.agravoProvido) {
            title += ' (agravo provido)';
        }

        return title;
    }

    async mostrarDetalhes() {
        const detalhes = await this.sessaoService.recuperarProcessoSessao(
            this.registro.sessaoId,
            this.registro.numeroProcesso
        );

        runInAction(() => {
            this.detalhesProcessoSessao = detalhes;
            this.abrirDialog = true;
        });
    }

    handleCloseDialog = () => {
        this.abrirDialog = false;
    };

    render() {
        if (this.resultadoJulgamento && this.resultadoJulgamento.codigo !== RESULTADO_JULGAMENTO.NAO_JULGADO.codigo) {
            return (
                <>
                    <Tooltip title={<Typography>{this.textoSituacaoJulgamento}</Typography>}>
                        <Gavel
                            style={{ color: this.corIcone, fillOpacity: '0.7' }}
                            onClick={this.mostrarDetalhes.bind(this)}
                            cursor={'pointer'}
                        />
                    </Tooltip>
                    {!!this.abrirDialog && (
                        <Dialog
                            onClose={this.handleCloseDialog}
                            open={this.abrirDialog}
                            maxWidth="md"
                        >
                            <DialogTitle>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        gap: 3
                                    }}
                                >
                                    <Typography
                                        display="inline"
                                        fontWeight="bold"
                                        color="primary"
                                        style={{ marginLeft: '5px', marginRight: '5px' }}
                                    >
                                        {this.observableProps.permitirAlterarSituacao
                                            ? 'Alterar situação do julgamento do processo'
                                            : 'Detalhes do julgamento do processo'}
                                    </Typography>
                                    <Box>
                                        <Typography
                                            display="inline"
                                            fontWeight="bold"
                                            color={this.corIcone}
                                            sx={{ mr: 1 }}
                                        >
                                            {this.registro.processo.numeroCompleto}&nbsp;
                                        </Typography>
                                        <Tooltip title={this.textoSituacaoJulgamento}>
                                            <Gavel
                                                style={{
                                                    verticalAlign: 'top',
                                                    color: this.corIcone,
                                                    fillOpacity: '0.7'
                                                }}
                                            />
                                        </Tooltip>
                                    </Box>
                                </Box>
                            </DialogTitle>
                            {!!this.detalhesProcessoSessao && (
                                <DialogContent dividers>
                                    <List
                                        style={{
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            justifyContent: 'center',
                                            margin: '0px 5px 0px',
                                            overflowX: 'auto'
                                        }}
                                    >
                                        {!this.observableProps.permitirAlterarSituacao &&
                                            !!this.detalhesProcessoSessao?.composicao && (
                                                <ListItem sx={{ gap: 0.5 }}>
                                                    <Typography fontWeight="bold">Composição:&nbsp;</Typography>
                                                    <>
                                                        {this.detalhesProcessoSessao.composicao.map((composicao) => {
                                                            return (
                                                                <Chip
                                                                    key={composicao.magistrado.sigla}
                                                                    label={composicao.magistrado.sigla}
                                                                    style={{ minWidth: '10ch', height: '24px' }}
                                                                />
                                                            );
                                                        })}
                                                    </>
                                                </ListItem>
                                            )}
                                        {!this.observableProps.permitirAlterarSituacao &&
                                            !!this.detalhesProcessoSessao?.informacaoProcessoSalaSessao
                                                ?.complementoAnotacoes && (
                                                <ListItem sx={{ gap: 0.5 }}>
                                                    <Typography
                                                        display="inline"
                                                        fontWeight="bold"
                                                    >
                                                        Anotações do Secretário:
                                                    </Typography>
                                                    <Typography
                                                        display="inline"
                                                        style={{ marginLeft: '5px' }}
                                                    >
                                                        {
                                                            this.detalhesProcessoSessao.informacaoProcessoSalaSessao
                                                                .complementoAnotacoes
                                                        }
                                                    </Typography>
                                                </ListItem>
                                            )}
                                        {!!this.observableProps.permitirAlterarSituacao && (
                                            <>
                                                <ListItem sx={{ pb: 0, gap: 0.5 }}>
                                                    <Typography
                                                        display="inline"
                                                        fontWeight="bold"
                                                    >
                                                        Data da apreciação:
                                                    </Typography>
                                                    <Typography display="inline">
                                                        {moment(
                                                            this.registro.dataJulgamento,
                                                            'DD-MM-YYYY-HH-mm-ss'
                                                        ).format('DD/MM/YYYY HH:mm')}
                                                    </Typography>
                                                </ListItem>
                                                <ListItem sx={{ pb: 0, gap: 0.5, pt: 1.5 }}>
                                                    <Typography
                                                        display="inline"
                                                        fontWeight="bold"
                                                    >
                                                        Situação atual:
                                                    </Typography>
                                                    <Typography
                                                        display="inline"
                                                        sx={{
                                                            fontWeight: '500',
                                                            color: this.corIcone
                                                        }}
                                                    >
                                                        {this.textoSituacaoJulgamento}
                                                    </Typography>
                                                </ListItem>
                                                <ListItem sx={{ pt: 0.5, gap: 0.5 }}>
                                                    <Typography
                                                        display="inline"
                                                        fontWeight="bold"
                                                    >
                                                        Alterar situação de julgamento:
                                                    </Typography>
                                                    <AlterarSituacaoJulgamento
                                                        registro={this.registro}
                                                        modoEdicao={true}
                                                    />
                                                </ListItem>
                                            </>
                                        )}
                                    </List>
                                </DialogContent>
                            )}
                            <DialogActions>
                                <Button
                                    onClick={this.handleCloseDialog}
                                    color="primary"
                                >
                                    Ok
                                </Button>
                            </DialogActions>
                        </Dialog>
                    )}
                </>
            );
        }
        return null;
    }
}

export default inject('stores')(observer(ResultadoJulgamento));
